<template>
  <div>
    <Nav></Nav>
    <div style="height: 80px"></div>
    <div class="download-contents">
        <div class="banner_img">
            <img src="https://oss.ansongqiubo.com/assets/home/xuanchuan.png" alt="" srcset="">
        </div>
    </div>
  </div>
</template>

<script>
import Nav from "../../component/Nav.vue";
export default {
  data() {
    return {};
  },
  components: {
    Nav,
  },
};
</script>

<style lang='scss' scope>

.download-contents {
  display: flex;
  justify-content: center;
  background:linear-gradient(to bottom right,#f9f9f9,50%,#f3f3f3);
  .banner_img{
      border-radius:4px;
      overflow: hidden;
      max-width:75vh;
      img{
      max-width:75vh;
      }
  }
}

</style>


// WEBPACK FOOTER //
// src/pages/template/bannerDownload.vue